export default "__VITE_ASSET__B3xO_UZm__"